import { Drawer } from 'vaul';
import { useTranslation } from 'react-i18next';
import type { NoticeItem } from '@/hooks/useNotices';

interface Props {
  notice: NoticeItem | null;
  onClose: () => void;
}

const CATEGORY_ICON: Record<Exclude<NoticeItem['category'], never>, string> = {
  important: 'priority_high',
  general: 'info',
  hr: 'people',
  safety: 'health_and_safety',
};

export function NoticeDrawer({ notice, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Drawer.Root open={Boolean(notice)} onOpenChange={(o) => !o && onClose()}>
      <Drawer.Portal>
        <Drawer.Overlay className="appr-drawer-overlay" />
        <Drawer.Content className="appr-drawer">
          <Drawer.Title className="sr-only">{notice?.title ?? ''}</Drawer.Title>
          <div className="appr-drawer-handle" />
          {notice && (
            <div className="appr-drawer-body">
              <div className="notice-drawer-cat" data-cat={notice.category}>
                <span className="material-symbols-outlined">{CATEGORY_ICON[notice.category]}</span>
                {t(`notices.cat_${notice.category}`)}
              </div>
              <div className="appr-drawer-title-text">{notice.title}</div>
              <div className="appr-drawer-sub">
                {notice.authorName} · {notice.date}
                {notice.attachmentCount > 0 && (
                  <> · <span className="material-symbols-outlined" style={{ fontSize: 14, verticalAlign: 'middle' }}>attach_file</span>
                    {notice.attachmentCount}
                  </>
                )}
              </div>
              <div className="appr-drawer-body-text">{notice.body}</div>
            </div>
          )}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
